<template src="./index.html"></template>

<script>
import agTableComp from '@/optionData/agTableComp'

const STATE_LABELS = {
    pending: '대기',
    open_processing: '공개 처리중',
    open_complete: '공개 완료',
    open_fail: '공개 실패',
}

const STATE_COLORS = {
    open_complete: '#28C76F',
    open_fail: '#EA5455',
    open_processing: '#FF9F43',
    pending: '#7a829e',
}

export default {
    name: 'openLog',

    data() {
        return {
            logList: [],
            logPage: { pageSize: 20, currentPage: 1, totalPage: 0 },
            logGridOptions: {
                context: { componentParent: this },
                frameworkComponents: agTableComp,
                onRowClicked: (event) => { this.openDetail(event) },
            },
            defaultColDef: {
                sortable: false,
                editable: false,
                resizable: true,
                suppressMenu: true,
            },
            logColumnDefs: [
                { headerName: '코드', field: 'ref_code', filter: false, width: 200 },
                {
                    headerName: '상태',
                    field: 'state',
                    filter: false,
                    width: 160,
                    cellRenderer: (data) => {
                        const label = STATE_LABELS[data.value] || data.value
                        const color = STATE_COLORS[data.value] || '#7a829e'
                        return `<span style="color:${color}; font-weight:600;">${label}</span>`
                    },
                },
                {
                    headerName: '처리일',
                    field: 'created_at',
                    filter: false,
                    width: 170,
                    cellRenderer: (data) => this.fixDate(data.value, 'yyyy-MM-dd HH:mm'),
                },
            ],
            detailData: null,
        }
    },

    computed: {
        isDark() { return this.$store.state.theme === 'dark' || this.$store.state.theme === 'semi-dark' },
    },

    watch: {
        'logPage.currentPage'() { this.loadLogs() },
    },

    mounted() {
        this.$nextTick(() => { this.loadLogs() })
    },

    methods: {
        loadLogs() {
            this.loadingShow()
            this.$store.dispatch('LIST_OPEN_LOG', {
                page: this.logPage.currentPage - 1,
                limit: this.logPage.pageSize,
                sort_field: 'created_at',
                sort_order: 'DESC',
            })
                .then(result => {
                    this.loadingHide()
                    this.logList = result.items || []
                    const total = result.total || 0
                    const rem = total % this.logPage.pageSize > 0 ? 1 : 0
                    this.logPage.totalPage = Math.floor(total / this.logPage.pageSize) + rem
                })
                .catch(error => {
                    this.loadingHide()
                    this.handleError(error)
                })
        },

        openDetail(event) {
            this.loadingShow()
            this.$store.dispatch('DETAIL_OPEN_LOG', { id: event.data.id })
                .then(result => {
                    this.loadingHide()
                    this.detailData = result
                    this.$modal.show('openDetail')
                })
                .catch(error => {
                    this.loadingHide()
                    this.handleError(error)
                })
        },

        stateLabel(state) { return STATE_LABELS[state] || state },
        stateColor(state) { return STATE_COLORS[state] || '#7a829e' },

        handleError(error) {
            if (!error || !error.response) return
            if (error.response.status === 401) {
                this.$store.dispatch('TOKEN_ITEM_CLEAR').then(() => this.$router.push('/login'))
            } else {
                this.alert({ msg: (error.response.data && error.response.data.message) || '오류가 발생했습니다.' })
            }
        },
    },
}
</script>

<style scoped>
.empty-state {
    text-align: center;
    padding: 32px 0;
    color: #7a829e;
    font-size: 13px;
}

.open-modal {
    background: #fff;
    color: #1a1f36;
}

.is-dark .open-modal {
    background: #10163a;
    color: #c2c6dc;
}

.modal-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.is-dark .modal-head {
    border-bottom-color: rgba(255, 255, 255, 0.06);
}

.state-tag {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 3px;
    font-size: 12px;
    font-weight: 600;
}

.detail-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
    background: rgba(0, 0, 0, 0.03);
    padding: 14px 18px;
    border-radius: 6px;
    margin-bottom: 20px;
    border: 1px solid rgba(0, 0, 0, 0.08);
}

.is-dark .detail-meta {
    background: rgba(255, 255, 255, 0.03);
    border-color: rgba(255, 255, 255, 0.05);
}

.meta-item {
    display: flex;
    flex-direction: column;
    gap: 3px;
}

.meta-label {
    font-size: 11px;
    color: #7a829e;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-transform: uppercase;
}

.meta-value {
    font-size: 14px;
    font-weight: 600;
    color: #1a1f36;
}

.is-dark .meta-value {
    color: #c2c6dc;
}

.meta-value.krw { color: #28C76F; }

.breakdown-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
}

.breakdown-table th {
    text-align: left;
    padding: 8px 14px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    color: #7a829e;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.6px;
}

.is-dark .breakdown-table th {
    border-bottom-color: rgba(255, 255, 255, 0.08);
}

.breakdown-table td {
    padding: 11px 14px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
    color: #1a1f36;
}

.is-dark .breakdown-table td {
    border-bottom-color: rgba(255, 255, 255, 0.04);
    color: #c2c6dc;
}

.breakdown-table tbody tr:hover {
    background: rgba(0, 0, 0, 0.03);
}

.is-dark .breakdown-table tbody tr:hover {
    background: rgba(255, 255, 255, 0.03);
}
</style>
